import {
  Component,
  computed,
  HostBinding,
  input,
  InputSignal,
  output,
  OutputEmitterRef,
  Signal,
  viewChild,
  ElementRef,
} from "@angular/core";
import { ButtonCtaComponent } from "@components/button-cta/button-cta.component";
import { CsIconModule } from "@components/icon";
import { Catalog } from "@cureskin/api-client/src/server-api";
import { ProductSize } from "./product.types";

@Component({
  selector: "app-product",
  imports: [CsIconModule, ButtonCtaComponent],
  templateUrl: "./product.component.html",
  styles: [
    `
      :host {
        display: flex;
        flex-direction: column;
        width: 120px;
        min-width: 120px;
      }

      :host(.product-size-medium) {
        width: 144px;
        min-width: 144px;
      }
    `,
  ],
  standalone: true
})
export class ProductComponent {
  @HostBinding('class.product-size-medium')
  get isMediumSize(): boolean {
    return this.size() === ProductSize.Medium;
  }

  productImageRef = viewChild<ElementRef<HTMLImageElement>>("productImageEl");
  product: InputSignal<Catalog | undefined> = input();
  productInCart: InputSignal<number | { quantity: number } | undefined> = input();
  isShopRevampExperimentOn: InputSignal<boolean> = input();
  isLocked: InputSignal<boolean> = input(false);
  size: InputSignal<ProductSize> = input<ProductSize>(ProductSize.Small);
  gotoProduct: OutputEmitterRef<Catalog> = output();
  addToCart: OutputEmitterRef<{ product: Catalog; image: HTMLImageElement }> =
    output();
  reomveFromCart: OutputEmitterRef<Catalog> = output();

  productImage: Signal<string> = computed(
    () =>
      this.product()?.rebrandedImageWithBackground?.[0] ||
      this.product()?.productUnboxedImage?.[0] ||
      this.product()?.images?.[0] ||
      (this.product() as { productImage?: string } | undefined)?.productImage
  );
  productTitle: Signal<string> = computed(() => this.product()?.title);

  productQuantity: Signal<number> = computed(() => {
    const value = this.productInCart();
    if (!value) return 0;
    if (typeof value === "number") return value;
    return value.quantity ?? 0;
  });

  addToCartAction(product: Catalog, image: HTMLImageElement): void {
    this.addToCart.emit({ product, image });
  }

  removeFromCartAction(product: Catalog): void {
    this.reomveFromCart.emit(product);
  }

  onGotoProduct(product: Catalog): void {
    this.gotoProduct.emit(product);
  }

  getProductImageElement(): HTMLImageElement | undefined {
    return this.productImageRef()?.nativeElement;
  }

  readonly ProductSize = ProductSize;
}
